<template>
  <div class="category-right">
    <img src="https://hbo-shenzhen.oss-cn-shenzhen.aliyuncs.com/web-img/new_index/content-right.png" />
    <div class="dropshipping">KakaClo DropShipping</div>
    <ul class="dropshipping-list">
      <li><span class="dropshipping-number">1</span><span class="dropshipping-subject">Listing Product</span></li>
      <li><span class="dropshipping-number">2</span><span class="dropshipping-subject">Receiving Order</span></li>
      <li><span class="dropshipping-number">3</span><span class="dropshipping-subject">Checking Quality</span></li>
      <li><span class="dropshipping-number">4</span><span class="dropshipping-subject">Fulfiling Package</span></li>
    </ul>

    <div class="help-center">Help Center<a href="/help-center" class="more">More<i class="iconfont icon-Frame_2"></i></a></div>
    <ul class="help-center-list">
      <li><a href="https://www.kakaclo.com/tutorial-content?category_id=1442847&name=Intro%20to%20KakaClo&locate=1" target="_blank"><span class="help-center-subject">What is KakaClo</span></a></li>
      <li><a href="https://www.kakaclo.com/tutorial-content?category_id=1442847&name=Intro%20to%20KakaClo&locate=2" target="_blank"><span class="help-center-subject">What makes us different?</span></a></li>
      <li><a href="https://www.kakaclo.com/tutorial-content?category_id=1442847&name=Intro%20to%20KakaClo&locate=7" target="_blank"><span class="help-center-subject">Register an Account</span></a></li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
  },
  data() {
    return {
      activeIndex: 0,
      clientHeight: 680,
      hoverVisible: false
    }
  },
  computed: {
  },
  created() {
  },
  mounted() {
    // this.getModuleHeight()
  },
  methods: {

  }
}
</script>

<style lang="scss" scoped>
  .dropshipping, .help-center {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    height: 24px;
    color: #303133;
    margin: 0 0 16px 20px;
  }
  .dropshipping-list {
    margin-left: 20px;
    li {
      height: 36px;
    }
  }
  .dropshipping-number {
    width: 16px;
    height: 16px;
    display: inline-block;
    border-radius: 16px;
    text-align: center;
    background: #9AC331;
    color: #FFF;
    margin-right: 8px;
    font-size: 10px;
    line-height: 16px;
  }
  .dropshipping-subject {
    color: #909399;
  }
  .help-center {
    margin-top: 18px;
  }
  .help-center-dot {
    width: 4px;
    height: 4px;
    border-radius: 4px;
    line-height: 16px;
    display: inline-block;
    background: #303133;
  }
  .help-center-list {
    margin-left: 36px;
    li {
      list-style: disc;
      height: 36px;
    }
  }
  .help-center-subject {
    color: #303133;
  }
  .help-center-subject:hover {
    color: #9AC331;
  }
  .more {
    font-size: 12px;
    float: right;
    margin-right: 20px;
    color: #909399;
    font-weight: 400;
    .icon-Frame_2 {
      font-size: 14px;
      color: #909399;
    }
  }
  .more:hover {
    color: #9AC331;
    .icon-Frame_2 {
      color: #9AC331;
    }
  }
</style>
